import React, { Component } from "react";
import App from "../components/App";
import { configureStore } from "../store/configure-store";
const { Provider } = require("react-redux");

//import { HashRouter, Match} from 'react-router-dom'

const store = configureStore();

export default class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Root.jsx